import { EnvironmentProviders, Provider } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { UrlInterceptor } from '@interceptors/url.interceptor';

export const APP_INTERCEPTORS: (Provider | EnvironmentProviders)[] = [
  { provide: HTTP_INTERCEPTORS, useClass: UrlInterceptor, multi: true },
];
